import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
//import Default from '../views/Default.vue';
import Layout from "../filters/layout.json";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    props: () => ({
      routes: [
        "inPort",
        "history",
        "arrival",
        "departure",
        "manoeuvreExpected",
        "anchored",
        "berthed",
        "hovering",
        "inManoeuvre",
      ],
    }),
  },
  {
    path: "/inPort",
    name: "In Port",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/in-port",
      name: "inPort",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/history",
    name: "History",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/history",
      name: "history",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: true,
    }),
  },
  {
    path: "/arrival",
    name: "Arrival",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/expected/arrival",
      name: "arrival",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/departure",
    name: "Departure",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/expected/departure",
      name: "departure",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/manoeuvreExpected",
    name: "Manoeuvre Expected",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "manoeuvre/expected",
      name: "manoeuvreExpected",
      layout: Layout,
      grid: "manoeuvreExpected",
      list: "manoeuvreExpected",
      enableDate: false,
    }),
  },
  {
    path: "/anchored",
    name: "Anchored",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/anchored",
      name: "anchored",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/berthed",
    name: "Berthed",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/berthed",
      name: "berthed",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/hovering",
    name: "Hovering",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/hovering",
      name: "hovering",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
  {
    path: "/inManoeuvre",
    name: "In Manoeuvre",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Default.vue"),
    props: () => ({
      url: "vessel-call/in-manoeuvre",
      name: "inManoeuvre",
      layout: Layout,
      grid: "default",
      list: "default",
      enableDate: false,
    }),
  },
];

const router = createRouter({
  base: process.env.NODE_ENV === "production" ? "/apdl.reports/" : "/",
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
